// Environment variables expected to be injected into the application
// If a variable is added below, it should be added to entrypoint.sh as well
interface EnvironmentVariables {
  apiRoot: string | undefined;
  sentryDSN: string | undefined;
  sentryEnvironment: string | undefined;
  oktaClientId: string | undefined;
  oktaIssuer: string | undefined;
  proxyPath: string | undefined;
}

// entrypoint.sh creates static/js/env.js which is loaded in a production build
// note, this doesn't apply to running locally through yarn/npm
interface Window {
  loadedEnv?: EnvironmentVariables;
}

// get loadedEnv as a temporary variable and give it a default
const e = (window as Window).loadedEnv || ({} as EnvironmentVariables);

// exposed Environment variables
// note process.env.* variables are injected at build or when running through yarn
export const Env: EnvironmentVariables = {
  apiRoot: e.apiRoot || import.meta.env.VITE_API_ROOT,
  sentryDSN: e.sentryDSN || import.meta.env.VITE_SENTRY_DSN,
  sentryEnvironment: e.sentryEnvironment || `${import.meta.env.ENVIRONMENT}:${import.meta.env.VITE_CLOUD}` || "local",
  oktaClientId: e.oktaClientId || import.meta.env.VITE_OKTA_CLIENT_ID,
  oktaIssuer: e.oktaIssuer || import.meta.env.VITE_OKTA_ISSUER,
  proxyPath: e.proxyPath || import.meta.env.VITE_PROXY_PATH,
};
